import { SkeletonBox } from '~shared/ui/skeleton-box';

const CardSkeleton = ({ rows = 4 }: { rows?: number }) => (
  <div
    className={`
      overflow-hidden rounded-xl border border-neutral-200 p-4 shadow-custom-md
    `}
  >
    <div className="flex items-center justify-between">
      <SkeletonBox className="h-5 w-36" />
      <SkeletonBox className="h-7 w-12 rounded-lg" />
    </div>
    <div className="mt-4 grid grid-cols-2 gap-4">
      {Array.from({ length: rows }).map((_, i) => (
        <div key={i} className="flex flex-col gap-1">
          <SkeletonBox className="h-3 w-24" />
          <SkeletonBox className="h-4 w-32" />
        </div>
      ))}
    </div>
  </div>
);

export const ReviewSkeleton = () => (
  <div className="flex flex-col gap-3">
    <CardSkeleton rows={8} />
    <CardSkeleton rows={6} />
    <CardSkeleton rows={4} />
    <CardSkeleton rows={4} />
    <CardSkeleton rows={2} />
  </div>
);
